<template>
  <v-snackbar
    color="error"
    :value="visible"
    timeout="10000"
    multi-line
    elevation="5"
    @input="hide"
  >
    <h5>Une erreur s'est produite lors de votre requête.</h5>
    <p>{{ message }}</p>
    <template v-slot:action="{ attrs }">
      <v-btn color="white" text v-bind="attrs" @click="hide">
        <v-icon> mdi-close-circle </v-icon></v-btn
      >
    </template>
  </v-snackbar>
</template>

<script>
export default {
  computed: {
    visible() {
      return this.$store.state.error.visible;
    },
    message() {
      return this.$store.state.error.message;
    },
  },
  methods: {
    hide() {
      this.$store.dispatch("hideError");
    },
  },
};
</script>

<style></style>
